var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-activity-management" },
    [
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            attrs: { placeholder: "请输入活动名称", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.loadConfig($event)
              },
            },
            model: {
              value: _vm.actName,
              callback: function ($$v) {
                _vm.actName = $$v
              },
              expression: "actName",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.loadConfig },
            },
            [_vm._v("\n      查询\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.handleAddActivity },
            },
            [_vm._v("\n      添加活动\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "99%" },
          attrs: { data: _vm.activityList, border: "", height: "500" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "id",
              label: "ID",
              "min-width": "80",
              fixed: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "活动名称", "min-width": "120" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "活动类型", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.type ? "普通活动" : "链接活动")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "活动时间", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("parseTime")(
                              scope.row.startTime,
                              "{y}-{m}-{d} {h}:{i}"
                            )
                          ) +
                          " 至 " +
                          _vm._s(
                            _vm._f("parseTime")(
                              scope.row.endTime,
                              "{y}-{m}-{d} {h}:{i}"
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "封面图", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.coverImg
                      ? _c("el-image", {
                          staticClass: "cover-image",
                          attrs: {
                            src: _vm.getImageUrl(scope.row.coverImg),
                            fit: "cover",
                            "preview-src-list": [
                              _vm.getImageUrl(scope.row.coverImg),
                            ],
                          },
                        })
                      : _c("span", [_vm._v("无")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", "min-width": "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: { type: scope.row.status ? "success" : "info" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.status ? "启用" : "未启用") +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "添加时间", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.createTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(scope.row)
                          },
                        },
                      },
                      [_vm._v("移除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "activityForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入活动名称" },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动类型", prop: "type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleTypeChange },
                      model: {
                        value: _vm.formData.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "type", $$v)
                        },
                        expression: "formData.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("普通活动"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("链接活动"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "活动时间", prop: "timeRange", required: "" },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.formData.timeRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "timeRange", $$v)
                      },
                      expression: "formData.timeRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "背景颜色" } },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.formData.backgroundColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "backgroundColor", $$v)
                      },
                      expression: "formData.backgroundColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "封面图", prop: "coverImg" } },
                [
                  _c(
                    "div",
                    { staticClass: "image-upload" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "cover-uploader",
                          attrs: {
                            action: "#",
                            headers: _vm.uploadHeaders,
                            "show-file-list": false,
                            "before-upload": _vm.beforeCoverUpload,
                            "on-success": _vm.handleCoverSuccess,
                            "on-error": _vm.handleCoverError,
                            "http-request": _vm.uploadCoverImage,
                          },
                        },
                        [
                          _vm.formData.coverImg
                            ? _c("img", {
                                staticClass: "cover-preview",
                                attrs: {
                                  src: _vm.getImageUrl(_vm.formData.coverImg),
                                },
                              })
                            : _c("i", {
                                staticClass: "el-icon-plus cover-uploader-icon",
                              }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.formData.coverImg
                        ? _c(
                            "div",
                            { staticClass: "image-actions" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.handleRemoveCover },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.formData.type
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "详情图", prop: "detailImg" } },
                      [
                        _c(
                          "div",
                          { staticClass: "image-upload" },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "detail-uploader",
                                attrs: {
                                  action: "#",
                                  headers: _vm.uploadHeaders,
                                  "show-file-list": false,
                                  "before-upload": _vm.beforeDetailUpload,
                                  "on-success": _vm.handleDetailSuccess,
                                  "on-error": _vm.handleDetailError,
                                  "http-request": _vm.uploadDetailImage,
                                },
                              },
                              [
                                _vm.formData.detailImg
                                  ? _c("img", {
                                      staticClass: "detail-preview",
                                      attrs: {
                                        src: _vm.getImageUrl(
                                          _vm.formData.detailImg
                                        ),
                                      },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus detail-uploader-icon",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.formData.detailImg
                              ? _c(
                                  "div",
                                  { staticClass: "image-actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: { click: _vm.handleRemoveDetail },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否报名" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.formData.apply,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "apply", $$v)
                              },
                              expression: "formData.apply",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("否"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.formData.type
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "链接地址", prop: "url" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入链接地址" },
                          model: {
                            value: _vm.formData.url,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "url", $$v)
                            },
                            expression: "formData.url",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "说明信息" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入说明信息",
                      resize: "vertical",
                    },
                    model: {
                      value: _vm.formData.explain,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "explain", $$v)
                      },
                      expression: "formData.explain",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "status", $$v)
                        },
                        expression: "formData.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("启用"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("未启用"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览二维码",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览二维码" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }